import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const FormationsPage = () => {
  const [cart, setCart] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<string | null>(null);

  const formations = [
    {
      id: 1,
      name: 'Influenceur Pro',
      price: 89,
      duration: '3h',
      level: 'Débutant à Intermédiaire',
      description: 'Apprenez les bases pour devenir un influenceur professionnel',
      image: 'https://public.readdy.ai/ai/img_res/8a6ee9d7e1c8b87a15b5b0c1a6ebd1d8.jpg',
      modules: [
        'Créer son personal branding',
        'Stratégie de contenu efficace',
        'Négocier ses collaborations',
        'Analytics et performance',
        'Monétisation de son audience',
      ],
      bonus: ['Kit de templates', 'Checklist collaboration', 'Accès groupe privé'],
    },
    {
      id: 2,
      name: 'Collabs & Contrats',
      price: 149,
      duration: '1h30',
      level: 'Intermédiaire',
      description: 'Maîtrisez l\'art de la négociation et des contrats d\'influence',
      image: 'https://readdy.ai/api/search-image?query=Business%20contract%20negotiation%20training%2C%20professional%20collaboration%20course%2C%20legal%20aspects%20of%20influencer%20marketing%2C%20educational%20content%20design&width=400&height=300&seq=formation-2&orientation=landscape',
      modules: [
        'Types de collaborations',
        'Tarification et négociation',
        'Aspects légaux et contrats',
        'Gestion des relations marques',
        'Éviter les pièges courants',
      ],
      bonus: ['Modèles de contrats', 'Grille tarifaire', 'Templates emails'],
    },
    {
      id: 3,
      name: 'Pack Shooting Photo Pro',
      price: 190,
      duration: '2h',
      level: 'Tous niveaux',
      description: 'Shooting photo professionnel + formation retouche + presets',
      image: 'https://readdy.ai/api/search-image?query=Professional%20photography%20shooting%20session%2C%20photo%20editing%20training%2C%20preset%20package%2C%20camera%20equipment%2C%20studio%20lighting%2C%20photography%20education&width=400&height=300&seq=formation-3&orientation=landscape',
      modules: [
        'Shooting photo professionnel 1h',
        'Formation retouche Lightroom',
        'Pack 20 presets exclusifs',
        'Techniques de composition',
        'Post-production avancée',
      ],
      bonus: ['Photos haute résolution', 'Presets personnalisés', 'Suivi retouche'],
      popular: true,
    },
    {
      id: 4,
      name: 'Pack Lancement Complet',
      price: 299,
      duration: '5h',
      level: 'Complet',
      description: 'Formation complète + coaching + shooting + media kit + EXCLUSIF Adel Saï',
      image: 'https://readdy.ai/api/search-image?query=Complete%20influencer%20launch%20package%2C%20comprehensive%20training%20program%2C%20coaching%20and%20mentoring%2C%20professional%20development%20course%2C%20premium%20education%20design&width=400&height=300&seq=formation-4&orientation=landscape',
      modules: [
        'Formation Influenceur Pro complète',
        'Session coaching 1h personnalisée',
        'Shooting photo professionnel',
        'Media kit personnalisé',
        'Stratégie de lancement 30 jours',
        '🔥 EXCLUSIF : Shooting avec Adel Saï (@Adofficielo)',
        '📱 5.4M TikTok • 2.6M Instagram • 1.6M Facebook',
        '🎬 Reel + TikTok avec mention collab garantis'
      ],
      bonus: ['Suivi 30 jours', 'Révision media kit', 'Accès VIP communauté', 'Contenu avec Adel Saï'],
      adelSai: true,
    },
  ];

  const addToCart = (formation: any) => {
    setCart([...cart, formation]);
  };

  const handleBuyNow = async (formation: any) => {
    setIsLoading(formation.id);
    
    try {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/create-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({
          productName: formation.name,
          price: formation.price,
          quantity: 1,
          productId: formation.id,
          productType: 'formation',
        }),
      });

      const data = await response.json();
      
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Erreur lors de la création du paiement');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la création du paiement');
    } finally {
      setIsLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-20 px-4 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Online%20education%20and%20training%20platform%2C%20digital%20learning%20environment%2C%20professional%20development%20courses%2C%20modern%20e-learning%20interface%2C%20orange%20and%20black%20aesthetic&width=1920&height=1080&seq=formations-hero&orientation=landscape"
              alt="Formations"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/70"></div>
          </div>

          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              <span className="text-orange-500">Formations</span> &amp; Presets
            </h1>
            <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
              Développez vos compétences d'influenceur avec nos formations expertes 
              et nos presets photo professionnels.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="#formations"
                className="px-8 py-4 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105"
              >
                Voir les formations
              </a>
              <Link
                to="/presets"
                className="px-8 py-4 bg-transparent border-2 border-orange-500 text-orange-500 font-semibold rounded-lg hover:bg-orange-500 hover:text-black transition-all duration-300"
              >
                Acheter un preset
              </Link>
            </div>
          </div>
        </section>

        {/* Formations Section */}
        <section id="formations" className="py-20 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Nos <span className="text-orange-500">Formations</span>
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {formations.map((formation) => (
                <div
                  key={formation.id}
                  className={`bg-gray-900 rounded-lg overflow-hidden hover:transform hover:scale-105 transition-all duration-300 ${
                    formation.popular ? 'border-2 border-orange-500' : ''
                  } ${formation.adelSai ? 'border-2 border-red-500' : ''}`}
                >
                  {formation.popular && (
                    <div className="bg-orange-500 text-black text-sm font-bold px-4 py-2 text-center">
                      PACK POPULAIRE
                    </div>
                  )}

                  {formation.adelSai && (
                    <div className="bg-gradient-to-r from-red-500 to-orange-500 text-white text-sm font-bold px-4 py-2 text-center animate-pulse">
                      PACK PREMIUM + ADEL SAÏ EXCLUSIF
                    </div>
                  )}

                  {/* Special badge for formations with Adel Saï */}
                  {formation.adelSai && (
                    <div className="absolute top-4 left-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-black px-3 py-1 rounded-full text-xs font-bold animate-pulse z-10">
                      + ADEL SAÏ EXCLUSIF
                    </div>
                  )}

                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={formation.image}
                      alt={formation.name}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="p-6">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <h3 className="text-xl font-bold text-white mb-1">{formation.name}</h3>
                        <p className="text-gray-400 text-sm">{formation.duration} • {formation.level}</p>
                      </div>
                      <p className="text-2xl font-bold text-orange-500">{formation.price}€</p>
                    </div>

                    <p className="text-gray-300 mb-6">{formation.description}</p>

                    <div className="mb-6">
                      <h4 className="text-white font-semibold mb-3">Modules inclus :</h4>
                      <ul className="space-y-2">
                        {formation.modules.map((module, index) => (
                          <li key={index} className="flex items-start text-gray-300 text-sm">
                            <i className="ri-check-line text-orange-500 mr-2 mt-0.5 flex-shrink-0"></i>
                            {module}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-white font-semibold mb-3">Bonus :</h4>
                      <ul className="space-y-2">
                        {formation.bonus.map((bonus, index) => (
                          <li key={index} className="flex items-start text-orange-400 text-sm">
                            <i className="ri-gift-line text-orange-500 mr-2 mt-0.5 flex-shrink-0"></i>
                            {bonus}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex gap-3 mb-3">
                      <button
                        onClick={() => addToCart(formation)}
                        className="flex-1 bg-transparent border border-orange-500 text-orange-500 font-semibold py-3 rounded-lg hover:bg-orange-500 hover:text-black transition-colors"
                      >
                        Ajouter au panier
                      </button>
                    </div>

                    <button
                      onClick={() => handleBuyNow(formation)}
                      disabled={isLoading === formation.id}
                      className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 ${
                        formation.popular
                          ? 'bg-orange-500 text-black hover:bg-orange-600'
                          : 'bg-orange-500 text-black hover:bg-orange-600'
                      } disabled:opacity-50 disabled:cursor-not-allowed`}
                    >
                      {isLoading === formation.id ? (
                        <>
                          <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                          Redirection...
                        </>
                      ) : (
                        <>
                          <i className="ri-secure-payment-line"></i>
                          S'inscrire maintenant
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20 px-4 bg-gray-900">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Pourquoi choisir nos <span className="text-orange-500">formations</span> ?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-user-star-line',
                  title: 'Expertise Reconnue',
                  description: 'Formateurs avec expérience réelle dans l\'influence',
                },
                {
                  icon: 'ri-time-line',
                  title: 'Accès à Vie',
                  description: 'Accédez à vos formations quand vous voulez, où vous voulez',
                },
                {
                  icon: 'ri-group-line',
                  title: 'Communauté Active',
                  description: 'Rejoignez notre réseau d\'influenceurs et créateurs',
                },
                {
                  icon: 'ri-medal-line',
                  title: 'Certificat',
                  description: 'Obtenez un certificat de réussite reconnu',
                },
              ].map((feature, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${feature.icon} text-2xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                  <p className="text-gray-400">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16">
              Témoignages <span className="text-orange-500">Étudiants</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  name: 'Sarah M.',
                  role: 'Influenceuse Mode',
                  followers: '25K followers',
                  text: 'Grâce à la formation, j\'ai doublé mes collaborations en 2 mois !',
                  rating: 5,
                },
                {
                  name: 'Kevin L.',
                  role: 'Content Creator',
                  followers: '15K followers',
                  text: 'Les conseils sur la négociation m\'ont fait économiser des heures.',
                  rating: 5,
                },
              ].map((testimonial, index) => (
                <div key={index} className="bg-gray-900 p-6 rounded-lg">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-orange-500 mr-1"></i>
                    ))}
                  </div>
                  <p className="text-gray-300 mb-4 italic">"{testimonial.text}"</p>
                  <div>
                    <p className="text-white font-semibold">{testimonial.name}</p>
                    <p className="text-gray-400 text-sm">{testimonial.role} • {testimonial.followers}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* Cart Summary */}
      {cart.length > 0 && (
        <div className="fixed bottom-4 right-4 bg-orange-500 text-black p-4 rounded-lg shadow-lg z-50">
          <p className="font-semibold">Panier: {cart.length} formation(s)</p>
          <p className="text-sm">
            Total: {cart.reduce((sum, item) => sum + item.price, 0)}€
          </p>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default FormationsPage;
